import { render, staticRenderFns } from "./PrepIngredientCombo.vue?vue&type=template&id=6dfdd04c&scoped=true"
import script from "./PrepIngredientCombo.vue?vue&type=script&lang=js"
export * from "./PrepIngredientCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfdd04c",
  null
  
)

export default component.exports